import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@ds/library.css";
import "./app/app.css";
import { App } from "./app/App";
import { registerServiceWorker } from "./shared/pwa/register";
import { applyStoredTheme } from "./shared/theme";

// Light is the default; dark only when the person picks it (saved on this device).
applyStoredTheme();

registerServiceWorker();

const root = document.getElementById("root");
if (!root) throw new Error("missing #root");
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
